import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const PdfPreviewModal = ({ isOpen, onClose, imageUrl }) => {
    const isPdf = imageUrl.endsWith(".pdf");
    console.log("imageURL", imageUrl);

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            aria-labelledby="document-preview-modal"
            aria-describedby="modal-to-preview-document"
            closeAfterTransition
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.75)",
                    outline: "none",
                    position: "relative",
                    padding: "20px",
                }}
            >
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        color: "white",
                    }}
                >
                    <CloseIcon />
                </IconButton>
                {isPdf ? (
                    <iframe src={imageUrl} title="PDF Preview" style={{ width: "80%", height: "90%", border: "none" }} />
                ) : (
                    <img src={imageUrl} alt="Preview" style={{ maxWidth: "100%", maxHeight: "90vh", objectFit: "contain" }} />
                )}
            </Box>
        </Modal>
    );
};

export default PdfPreviewModal;
